import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";
import { IntegrationFormValues } from "@modules/erpIntegrations/validations";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { editIntegrationService } from "./service";
import { UseEditIntegrationMutationOptions } from "./types";

export function useEditIntegrationMutation(
  options?: UseEditIntegrationMutationOptions
) {
  const { open } = useNotification();

  return useMutation<
    IntegrationCatalog,
    ApiError,
    { id: string; data: IntegrationFormValues }
  >({
    mutationFn: ({ id, data }) => editIntegrationService(id, data),
    ...options,
    onError: (error, variables, context) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
      options?.onError?.(error, variables, context);
    },
  });
}
